<template>

                <div class="modifyworkorder">
                    <div class="modifyWorkOrderText">
                        <span class="modifyUserName"> {{modifyLogInfo.operatorInfo==null?modifyLogInfo.operatorId:modifyLogInfo.operatorInfo.name}}({{modifyLogInfo.operatorInfo.groupName}})</span>
                        <span v-if="modifyLogInfo.changeType!='REMIND'">
                            将
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='priority'">优先级</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='status'">状态</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='clientId'">客户</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='followersId'">关注人</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='assigneeGroupId'">受理组</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='assigneeId'">受理人</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='template'">工单模板</span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.changeType==='FIELD'&&modifyLogInfo.field!=null">{{modifyLogInfo.field.name}}</span>
                            由
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='priority'">{{priorityOldName}}</span>
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='status'">{{statusOldName}}</span>
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='followersId'">
                                <span v-if="modifyLogInfo.oldVal.length > 0">
                                    <span v-for="(item,index) in modifyLogInfo.oldVal" :key="item.id">
                                        {{index==0?item.name:","+item.name}}
                                    </span>
                                </span>
                                <span v-if="modifyLogInfo.oldVal.length === 0">
                                    <span>无</span>
                                </span>
                            </span>
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='assigneeGroupId'">{{assigneeGroupOldName}}</span>
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='assigneeId'">{{assigneePersonOldName}}</span>
                            <span class="beforeAttr" v-if="modifyLogInfo.attribute==='template'">{{templateOldName}}</span>
                            <span class="beforeAttr" v-if="modifyLogInfo.changeType==='FIELD'">
                                <span v-if="modifyLogInfo.oldVal!=null && modifyLogInfo.oldVal.name!=='' && modifyLogInfo.oldVal.name!=null">
                                  <span v-if="modifyLogInfo.field!==null">
                                    <span v-if="modifyLogInfo.field.type!=='DATE_PICKER'&&modifyLogInfo.field.type!=='TIME_PICKER'">{{modifyLogInfo.oldVal.name}}</span>
                                    <span v-if="modifyLogInfo.field.type==='DATE_PICKER'">{{new Date(modifyLogInfo.oldVal.name).Format('yyyy-MM-dd')}}</span>
                                    <span v-if=" modifyLogInfo.field.type==='TIME_PICKER'">{{new Date(modifyLogInfo.oldVal.name).Format('hh:mm:ss')}}</span>
                                       </span>
                                  <span v-if="modifyLogInfo.field===null">
                                   {{modifyLogInfo.oldVal.name}}
                                  </span>
                                </span>
                               <span v-if="modifyLogInfo.oldVal==null || modifyLogInfo.oldVal.name=='' || modifyLogInfo.oldVal.name==null">无</span>

                                    </span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='clientId'">
                                <span v-if="modifyLogInfo.oldVal!==null">{{modifyLogInfo.oldVal.name}}</span>
                                <span v-if="modifyLogInfo.oldVal==null">无</span>
                            </span>
                            更改为
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='priority'">{{priorityNewName}}</span>
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='status'">{{statusNewName}}</span>
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='followersId'">
                                <span v-if=" modifyLogInfo.newVal.length > 0">
                                    <span v-for="(item,index) in modifyLogInfo.newVal" :key="item.id">
                                        {{index==0?item.name:","+item.name}}
                                    </span>
                                </span>
                                <span v-if=" modifyLogInfo.newVal.length === 0">
                                <span>无</span>
                                </span>
                            </span>
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='assigneeGroupId'">{{assigneeGroupNewName}}</span>
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='assigneeId'">{{assigneePersonNewName}}</span>
                            <span class="afterAttr" v-if="modifyLogInfo.attribute==='template'">{{modifyLogInfo.newVal.name}}</span>
                            <span class="afterAttr" v-if="modifyLogInfo.changeType==='FIELD'">
                                <span v-if="modifyLogInfo.newVal!=null && modifyLogInfo.newVal.name!=='' && modifyLogInfo.newVal.name!=null">
                                  <span v-if="modifyLogInfo.field!==null">
                                    <span v-if="modifyLogInfo.field.type!=='DATE_PICKER'&&modifyLogInfo.field.type!=='TIME_PICKER'">
                                       {{modifyLogInfo.newVal.name}}
                                    </span>
                                     <span v-if=" modifyLogInfo.field.type==='DATE_PICKER'">{{new Date(modifyLogInfo.newVal.name).Format('yyyy-MM-dd')}}</span>
                                <span v-if=" modifyLogInfo.field.type==='TIME_PICKER'">{{new Date(modifyLogInfo.newVal.name).Format('hh:mm:ss')}}</span>

                                  </span>
                                  <span v-if="modifyLogInfo.field === null">
                                     {{modifyLogInfo.newVal.name}}
                                  </span>
                                </span>
                               <span v-if="modifyLogInfo.newVal==null || modifyLogInfo.newVal.name=='' || modifyLogInfo.newVal.name==null">无</span>
                                </span>
                            <span class="ModifyAttr" v-if="modifyLogInfo.attribute==='clientId'">
                                <span>{{modifyLogInfo.newVal.name}}</span>
                            </span>
                        </span>
                        <span class="ModifyAttr" v-if="modifyLogInfo.changeType=='REMIND'">
                            进行了催单。
                        </span>
                    </div>
                    <div class="modifyTime" >{{dateFormat(modifyLogInfo.updateTime)}}</div>

              <!--  <div v-if="modifyLogInfo.attribute==='status'" class="modifyworkorder">
                    <div class="modifyWorkOrderText">
                        <span class="modifyUserName"> 用户姓名</span>
                        将
                        <span class="ModifyAttr">状态</span>
                        由
                        <span class="beforeAttr">{{statusOldName}}</span>
                        更改为
                        <span class="afterAttr">{{statusNewName}}</span>
                    </div>
                    <div class="modifyTime">{{dateFormat(modifyLogInfo.updateTime)}}</div>
                </div>-->

            </div>
</template>

<script>

    export default {
        name: "ModifyWorkOrderAttr",
        data(){
            return{
                statusAttr:'',
                priorityAttr:'',
                priorityInfoList:[],
                statusInfoList:[],
                priorityOldName:'',
                priorityNewName:'',
                statusOldName:'',
                statusNewName:'',
                followOldName:[],
                followNewName:[],
                assigneeGroupOldName:'',
                assigneeGroupNewName:'',
                assigneePersonOldName:'',
                assigneePersonNewName:'',
                templateNewName:'',
                templateOldName:'',
              groupName:'',
              group:[]
            }
        },
        props:{
            modifyLogInfo:{
                type:Object,
                default(){
                    return {}
                }
            },
            refrsh:Number
        },
      beforeCreate() {

      },
      beforeMount() {
      },

      mounted() {

            //修改的是优先级的时候
            if(this.modifyLogInfo.oldVal==='MIDDLE')
                this.priorityOldName= '中'
            if(this.modifyLogInfo.oldVal==='HIGH')
                this.priorityOldName= '高'
            if(this.modifyLogInfo.oldVal==='URGENT')
                this.priorityOldName= '紧急'
            if(this.modifyLogInfo.oldVal==='LOW')
                this.priorityOldName= '低'
            if(this.modifyLogInfo.newVal==='MIDDLE')
                this.priorityNewName= '中'
            if(this.modifyLogInfo.newVal==='HIGH')
                this.priorityNewName= '高'
            if(this.modifyLogInfo.newVal==='URGENT')
                this.priorityNewName= '紧急'
            if(this.modifyLogInfo.newVal==='LOW')
                this.priorityNewName= '低'

            //修改的是状态的时候
            if(this.modifyLogInfo.attribute==='status')
            {
                this.statusOldName=this.modifyLogInfo.oldVal.name
                this.statusNewName=this.modifyLogInfo.newVal.name
            }
            //修改的是关注人的时候
            if(this.modifyLogInfo.attribute==='followersId')
            {
                if(this.modifyLogInfo.oldVal.length ===0)
                  {
                      this.followOldName=[]
                  }
                  else
                  {
                      this.followOldName=this.modifyLogInfo.oldVal


                  }
                  if(this.modifyLogInfo.newVal.length===0)
                  {
                      this.followOldName=[]
                  }
                else
                  {
                      this.followNewName=this.modifyLogInfo.newVal
                  }
          }



          //修改负责组的时候
            if(this.modifyLogInfo.attribute==='assigneeGroupId')
            {
                if(this.modifyLogInfo.oldVal==null)
                    this.assigneeGroupOldName='无'
                else
                {

                    this.assigneeGroupOldName=this.modifyLogInfo.oldVal.name


                }
                if(this.modifyLogInfo.newVal==null)
                {
                    this.assigneeGroupNewName='无'
                }
                else
                {
                    this.assigneeGroupNewName=this.modifyLogInfo.newVal.name
                }

            }
                if(this.modifyLogInfo.attribute==='assigneeId')
                {
                    if(this.modifyLogInfo.oldVal==null)
                        this.assigneePersonOldName='无'
                    else
                    {

                        this.assigneePersonOldName=this.modifyLogInfo.oldVal.name


                    }
                    if(this.modifyLogInfo.newVal==null)
                    {
                        this.assigneePersonNewName='无'
                    }
                    else
                    {
                        this.assigneePersonNewName=this.modifyLogInfo.newVal.name
                    }

                }
                    if(this.modifyLogInfo.attribute==='template')
                    {
                        if(this.modifyLogInfo.oldVal==null)
                            this.templateOldName='无'
                        else
                        {

                            this.templateOldName=this.modifyLogInfo.oldVal.name



                        }
                    }

          console.log(this.modifyLogInfo)
        },
        methods:{

            dateFormat(time){
                let date=new Date(time);
                let year=date.getFullYear();
                /* 在日期格式中，月份是从0开始的，因此要加0
                 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
                 * */
                let month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
                let day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
                let hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
                let minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
                let seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
                // 拼接
                return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
            }
        },
        watch:{
            refrsh(a){
                if(a===1)
                    console.log('aaaa')
            }
        }
    }
</script>

<style scoped lang="less">
.modifyworkorder{
    border-radius: 5px;
    background-color: #AAAAAA;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: white;
    margin-bottom: 20px;

}
    .modifyWorkOrderText{
        margin-left: 10px;
        font-size: 12px;

    }
    .modifyUserName,.ModifyAttr,.beforeAttr,.afterAttr{
        font-weight: 600;
        font-size: 13px;

    }
    .modifyTime{
       margin: 0 4px;
    }
</style>